module.exports = __webpack_public_path__ + "img/engine.381df805.png";